export const FLEX_DIRECTION_COLUMN = {
  display: 'flex',
  flexDirection: 'column',
}
